import { CommonEnums } from 'src/app/shared/common.enums';

export class Usr_Def_Fun {
	udf_Id: number;
	nm: string;
	aliasNm: string;
	className: string;
	tempName: string;
	description: string;
	dbtyp_Id: number;
	jarFile: string;
	returnTyp: string;
	syntax: string;
	editable: string;
	valid_Cd: string;
	ver: string;
	updateDt: Date;
	updateBy: string;
	prec: number;
	scale: number;

	constructor() {
		this.setDefaults()
	}

	setDefaults(): void {
		this.udf_Id = CommonEnums.defaults.LONG_VAL;
		this.nm = CommonEnums.defaults.STRING_EMPTY;
		this.aliasNm = CommonEnums.defaults.STRING_EMPTY;
		this.className = CommonEnums.defaults.STRING_EMPTY;
		this.tempName = CommonEnums.defaults.STRING_EMPTY;
		this.description = CommonEnums.defaults.STRING_EMPTY;
		this.dbtyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.jarFile = CommonEnums.defaults.STRING_EMPTY;
		this.returnTyp = CommonEnums.defaults.STRING_EMPTY;
		this.syntax = CommonEnums.defaults.STRING_EMPTY;
		this.editable = CommonEnums.defaults.STRING_VAL_YES;
		this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.ver = CommonEnums.defaults.STRING_EMPTY;
		this.updateDt = new Date();
		this.updateBy = CommonEnums.defaults.STRING_EMPTY;
		this.prec = CommonEnums.defaults.DEFAULT_INT_VAL;
		this.scale = CommonEnums.defaults.DEFAULT_INT_VAL;
	}

	getPrimaryKey(): string {
		return this.udf_Id.toString();
	}

	copy(): Usr_Def_Fun {
		let usr_Def_FunTmp: Usr_Def_Fun = new Usr_Def_Fun();

		usr_Def_FunTmp.udf_Id = this.udf_Id;
		usr_Def_FunTmp.nm = this.nm;
		usr_Def_FunTmp.aliasNm = this.aliasNm;
		usr_Def_FunTmp.className = this.className;
		usr_Def_FunTmp.tempName = this.tempName;
		usr_Def_FunTmp.description = this.description;
		usr_Def_FunTmp.dbtyp_Id = this.dbtyp_Id;
		usr_Def_FunTmp.jarFile = this.jarFile;
		usr_Def_FunTmp.returnTyp = this.returnTyp;
		usr_Def_FunTmp.syntax = this.syntax;
		usr_Def_FunTmp.editable = this.editable;
		usr_Def_FunTmp.valid_Cd = this.valid_Cd;
		usr_Def_FunTmp.ver = this.ver;
		usr_Def_FunTmp.updateDt = this.updateDt;
		usr_Def_FunTmp.updateBy = this.updateBy;
		usr_Def_FunTmp.prec = this.prec;
		usr_Def_FunTmp.scale = this.scale;

		return usr_Def_FunTmp;
	}

	copyFrom(usr_Def_FunTmp: Usr_Def_Fun): void {
		this.udf_Id = usr_Def_FunTmp.udf_Id;
		this.nm = usr_Def_FunTmp.nm;
		this.aliasNm = usr_Def_FunTmp.aliasNm;
		this.className = usr_Def_FunTmp.className;
		this.tempName = usr_Def_FunTmp.tempName;
		this.description = usr_Def_FunTmp.description;
		this.dbtyp_Id = usr_Def_FunTmp.dbtyp_Id;
		this.jarFile = usr_Def_FunTmp.jarFile;
		this.returnTyp = usr_Def_FunTmp.returnTyp;
		this.syntax = usr_Def_FunTmp.syntax;
		this.editable = usr_Def_FunTmp.editable;
		this.valid_Cd = usr_Def_FunTmp.valid_Cd;
		this.ver = usr_Def_FunTmp.ver;
		this.updateDt = usr_Def_FunTmp.updateDt;
		this.updateBy = usr_Def_FunTmp.updateBy;
		this.prec = usr_Def_FunTmp.prec;
		this.scale = usr_Def_FunTmp.scale;
	}

	compare(usr_Def_FunTmp: Usr_Def_Fun): string {
		let usr_Def_FunString: string = this.toString(false);
		let usr_Def_FunTmpString: string = usr_Def_FunTmp.toString(false);

		if (usr_Def_FunString != usr_Def_FunTmpString) {
			return usr_Def_FunString + ', ' + usr_Def_FunTmpString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "Usr_Def_Fun [udf_Id=" + this.udf_Id + ", nm=" + this.nm + ", aliasNm=" + this.aliasNm +
			", className=" + this.className + ", tempName=" + this.tempName + ", description=" + this.description +
			", dbtyp_Id=" + this.dbtyp_Id + ", jarFile=" + this.jarFile + ", returnTyp=" + this.returnTyp +
			", syntax=" + this.syntax + ", editable=" + this.editable + ", valid_Cd=" + this.valid_Cd +
			", prec=" + this.prec + ", scale=" + this.scale;

		if (isNotCompare) {
			str += ", ver=" + this.ver + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy;
		}

		str += ']';
		return str;
	}
}
